import React from 'react'
import { Grid } from '@mui/material'

import PageWrapper from 'Pages/@PageWrapper'
import { TourProvider, TourTarget } from "@tour"
import { CUSTOM_DASHBOARD_ROUTES } from '@constants/routes'
import {isSystemBusy} from "@signals";
import {isEmptyDynamicAssortment} from "./@signals";
import DynamicAssortmentFilters from "./Filters";
import DynamicAssortmentTable from "./Table";

export default function DynamicAssortmentPage() {

    const props = {
        head: CUSTOM_DASHBOARD_ROUTES.DYNAMIC_ASSORTMENT_TITLE,
        title: CUSTOM_DASHBOARD_ROUTES.DYNAMIC_ASSORTMENT_TITLE,
        subtitle: CUSTOM_DASHBOARD_ROUTES.DYNAMIC_ASSORTMENT_SUBTITLE,
        isEmpty: isEmptyDynamicAssortment.value,
        hasErrors: isSystemBusy.value,
        actions: null,
        tourPageKey: "dynamicAssortment"
    }

    return <PageWrapper {...props} filters={<DynamicAssortmentFilters/>}>
        <Grid container spacing={2}>
            <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="dynamic-assortment-table" height={350} />
                <DynamicAssortmentTable />
            </Grid>
        </Grid>
    </PageWrapper>
}